import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryTaxes.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import Price from '@synergycms_core/components/generic/Price';
import classnames from 'classnames/bind';
import { getTaxText, splitMandatoryFees } from '../../../../utils';

const AvailMainSideSummaryTaxes = class AvailMainSideSummaryTaxes extends React.Component {
  static displayName = 'AvailMainSideSummaryTaxes';

  render() {
    const { config, theme } = this.props,
      {
        taxes,
        included,
        title,
        cityTax,
        summaryBreakdownMode,
        stepCode,
        summaryPriceBreakdown
      } = config;

    const { classes } = theme.styles;
    let cx = classnames.bind(classes);

    // GLOSARIO.md FCL-003
    const { mandatoryFees, otherTaxes: parsedTaxes } = summaryPriceBreakdown && taxes && taxes.length > 0
      ? splitMandatoryFees(taxes)
      : { mandatoryFees: [], otherTaxes: taxes };
    const mandatoryFeesTotal = mandatoryFees.reduce((sum, tax) => sum + tax.tax_amount, 0);

    return (
      <>
        {title && (
          <div className={[classes.contentModuleRow, classes.contentFlexRow].join(' ')}>
            <div className={[classes.contentModuleCell, classes.contentFlexCell].join(' ')}>
              <RichText
                text={title}
                innerStyle={['roboto11Black700', 'bold', classes.fontSize12]}
                translate={true}
                ucFirst={true}
              />
            </div>
          </div>
        )}
        {parsedTaxes && parsedTaxes.length === 1 && included && (
          <div className={classes.contentModuleRow}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <RichText
                ucFirst={true}
                text={'_%impuestos incluidos%_'}
                innerStyle={['roboto15GrayBold']}
                translate={true}
              />
              {' '}
              <RichText
                text={parsedTaxes[0].is_percent ? ' (' + parsedTaxes[0].value + '%)' : ''}
                innerStyle={['roboto15GrayBold']}
                translate={true}
              />
            </div>
            <div className={[classes.contentModuleCell, classes.short].join(' ')}>
              <Price
                innerStyle={['roboto13GrayBold']}
                amount={parsedTaxes[0].tax_amount}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
            </div>
          </div>
        )}
        {mandatoryFees.length === 1 && included && (
          <div className={classes.contentModuleRow}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <RichText
                ucFirst={true}
                text={mandatoryFees[0].name}
                innerStyle={['roboto15GrayBold']}
                translate={true}
              />
            </div>
            <div className={[classes.contentModuleCell, classes.short].join(' ')}>
              <Price
                innerStyle={['roboto13GrayBold']}
                amount={mandatoryFeesTotal}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
            </div>
          </div>
        )}
        {summaryPriceBreakdown || (parsedTaxes && parsedTaxes.length > 0 && ( parsedTaxes.length > 1 || !included )) && (
          <>
            {included && (
              <div className={[classes.contentModuleRow].join(' ')}>
                <RichText
                  text={'_%impuestos incluidos%_'}
                  innerStyle={['roboto15GrayBold', 'bold', classes.taxesCell, classes.taxesTitle]}
                  translate={true}
                  ucFirst={true}
                />
              </div>
            )}
            {!included && (
              <div className={[classes.contentModuleRow].join(' ')}>
                <RichText
                  text={'_%no incluido%_'}
                  innerStyle={['roboto11Black400', classes.fontSize12, classes.taxesCell, classes.taxesTitle]}
                  translate={true}
                  ucFirst={true}
                />
              </div>
            )}
            {parsedTaxes.map((tax, index) => (
              <div className={[classes.contentModuleRow, classes.removeGap, included ? classes.removeGapLarge : ''].join(' ')} key={'tax-' + index}>
                <div className={[classes.contentModuleCell, classes.large, cx({taxesCell: index === 0}) ].join(' ')}>
                  <RichText
                    text={getTaxText(tax, summaryBreakdownMode)}
                    innerStyle={['roboto11SoftGray300', classes.fontSize12, classes.taxes]}
                    translate={true}
                  />
                  {' '}
                  <RichText
                    text={tax.is_percent ? ' (' + tax.value + '%)' : ''}
                    innerStyle={['roboto11SoftGray300', classes.fontSize12, classes.taxes]}
                    translate={true}
                  />
                </div>
                <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short, cx({taxesCell: index === 0})].join(' ')}>
                  <Price
                    innerStyle={['roboto11SoftGray300', classes.fontSize12, classes.priceNumbers, classes.taxes]}
                    amount={tax.tax_amount}
                    forceHotelCurrency={stepCode === 'confirmation'}
                  />
                </div>
              </div>
            ))}
          </>
        )}
        {cityTax && (
          <div className={[classes.contentModuleRow, classes.contentFlexRow].join(' ')}>
            <div className={[classes.contentModuleCell, classes.contentFlexCell, classes.flexCellFullWidth, classes.alignLeft].join(' ')}>
              <RichText dangerouslySetInnerHTML={cityTax} innerStyle={['roboto11Black400', classes.fontSize12]} />
            </div>
          </div>
        )}
      </>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  
  return {
    stepCode: stepCode,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'taxes',
    'included',
    'title',
    'cityTax',
    'summaryBreakdownMode',
    'stepCode',
    'summaryPriceBreakdown'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryTaxes);
